module.exports = __webpack_public_path__ + "static/media/thumbnail.5cfcc0be.jpg";